import type { Member } from './constants';

export function getDisplayName(member: Member | null | undefined): string {
  if (member?.firstName || member?.lastName) {
    return [member.firstName, member.lastName].filter(Boolean).join(' ');
  }

  if (member?.email) {
    return member.email;
  }

  return 'User';
}
